<template>
  <svg
    width="164"
    height="164"
    viewBox="0 0 164 164"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M47.3262 73.0312L81.9199 154.591L120.518 73.0312H47.3262Z"
      fill="#72ADF1"
    />
    <path
      d="M47.3262 73.0312L81.9199 154.591L120.518 73.0312H47.3262Z"
      fill="url(#paint0_linear_8239_21727)"
    />
    <path
      d="M47.3262 73.0312L81.9199 154.591L120.518 73.0312H47.3262Z"
      fill="url(#paint1_linear_8239_21727)"
    />
    <path
      d="M38.6777 40.8398L10.4902 78.7969L11.8548 80.1256H57.2739L56.7754 78.7969H59.1752L84.541 40.8398H82H38.6777Z"
      fill="url(#paint2_linear_8239_21727)"
    />
    <path
      d="M38.6777 40.8398L10.4902 78.7969L11.8548 80.1256H57.2739L56.7754 78.7969H59.1752L84.541 40.8398H82H38.6777Z"
      fill="url(#paint3_linear_8239_21727)"
    />
    <path
      d="M38.6777 40.8398L10.4902 78.7969L11.8548 80.1256H57.2739L56.7754 78.7969H59.1752L84.541 40.8398H82H38.6777Z"
      fill="url(#paint4_linear_8239_21727)"
    />
    <path
      d="M81.95 154.641L10.4902 78.7969H56.7754L81.95 154.641Z"
      fill="url(#paint5_linear_8239_21727)"
    />
    <path
      d="M81.95 154.641L10.4902 78.7969H56.7754L81.95 154.641Z"
      fill="url(#paint6_linear_8239_21727)"
    />
    <path
      d="M125.202 40.8398L153.39 78.7969L151.248 80.7194H106.461L107.104 78.7969H104.668L81.8799 43.587V40.8398H125.202Z"
      fill="url(#paint7_radial_8239_21727)"
    />
    <path
      d="M125.202 40.8398L153.39 78.7969L151.248 80.7194H106.461L107.104 78.7969H104.668L81.8799 43.587V40.8398H125.202Z"
      fill="url(#paint8_linear_8239_21727)"
    />
    <path
      d="M81.9204 154.591L153.41 78.7969H107.125L81.9204 154.591Z"
      fill="url(#paint9_radial_8239_21727)"
    />
    <path
      d="M81.9204 154.591L153.41 78.7969H107.125L81.9204 154.591Z"
      fill="url(#paint10_linear_8239_21727)"
    />
    <path
      d="M81.9204 154.591L153.41 78.7969H107.125L81.9204 154.591Z"
      fill="url(#paint11_linear_8239_21727)"
    />
    <path
      d="M56.7754 78.7963H107.104L81.9399 40.9297L56.7754 78.7963Z"
      fill="url(#paint12_linear_8239_21727)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8239_21727"
        x1="83.9219"
        y1="76.0982"
        x2="83.9219"
        y2="86.346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#72C8F9" />
        <stop
          offset="1"
          stop-color="#73AEF2"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8239_21727"
        x1="98.3548"
        y1="128.704"
        x2="81.7305"
        y2="125.516"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#73D2FF" />
        <stop
          offset="1"
          stop-color="#73AEF2"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8239_21727"
        x1="57.2559"
        y1="76.875"
        x2="37.0762"
        y2="50.6094"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329505"
          stop-color="#2E97D8"
        />
        <stop
          offset="1"
          stop-color="#1C82CA"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8239_21727"
        x1="12.7324"
        y1="82.3203"
        x2="32.2715"
        y2="67.2656"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2E8BDB" />
        <stop
          offset="1"
          stop-color="#2E8BDB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8239_21727"
        x1="69.5469"
        y1="63.9146"
        x2="65.1062"
        y2="61.068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#32B3EA" />
        <stop
          offset="1"
          stop-color="#32B3EA"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_8239_21727"
        x1="46.2201"
        y1="78.7969"
        x2="81.95"
        y2="152.388"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.379031"
          stop-color="#296BCC"
        />
        <stop
          offset="1"
          stop-color="#3E7DE1"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_8239_21727"
        x1="46.2201"
        y1="78.7969"
        x2="46.2201"
        y2="80.8789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2D75D2" />
        <stop
          offset="1"
          stop-color="#2D75D2"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint7_radial_8239_21727"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(92.1699 64.0625) rotate(-5.73208) scale(42.4937 57.4324)"
      >
        <stop stop-color="#20D5FC" />
        <stop
          offset="1"
          stop-color="#20BFF7"
        />
      </radialGradient>
      <linearGradient
        id="paint8_linear_8239_21727"
        x1="100.338"
        y1="69.668"
        x2="103.541"
        y2="67.5859"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.17"
          stop-color="#20D0F6"
        />
        <stop
          offset="1"
          stop-color="#20D0F6"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint9_radial_8239_21727"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(88.3267 151.508) rotate(-60.9647) scale(60.4487 31.6939)"
      >
        <stop stop-color="#42A2EC" />
        <stop
          offset="1"
          stop-color="#3294E4"
        />
      </radialGradient>
      <linearGradient
        id="paint10_linear_8239_21727"
        x1="90.0083"
        y1="127.604"
        x2="92.5708"
        y2="128.605"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#368FE1" />
        <stop
          offset="1"
          stop-color="#368FE1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint11_linear_8239_21727"
        x1="117.665"
        y1="77.1953"
        x2="117.665"
        y2="82.4805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#309EE9" />
        <stop
          offset="1"
          stop-color="#309EE9"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_8239_21727"
        x1="100.818"
        y1="57.976"
        x2="56.7754"
        y2="88.726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6CE8FE" />
        <stop
          offset="0.642405"
          stop-color="#68CAEA"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
